import { folderWorkplaceFrag, serviceMedicalProcedureGridItemFrag } from './service.types';
import { serviceUserFrag } from './user.types';
import { folderGridItemFrag, folderWorkgroupGridItemFrag } from './folder.types';

export const schedulerVoucherPrescribedMedicalProceduresFrag = `
    id
    code
    voucherId
    voucher {
        id
        voucherPrevId
        type
        sequenceNumber
        doctor {
            ${serviceUserFrag}
        }
    }
    service {
        id
        name
    }
    serviceMedicalProcedureId
    serviceMedicalProcedure {
        ${serviceMedicalProcedureGridItemFrag}
    }
    canBeBilled
    canBeBilledWeekend
    canBeBilledNight
    continuousOperation
    courseDescription
    recordTemplate
    usualNumberOfApplications
    frequency
`;

export const personAppointmentFrag = `
    id
    name
    surname
    sex
    titleBeforeName
    titleAfterName
    birthdate
    image
`;

export const schedulerAppointmentFrag = `
    id
    startTime
    endTime
    location
    isAllDay
    isBlock
    isReadonly
    recurrenceRule
    recurrenceException
    recurrenceId
    startTimezone
    endTimezone
    description
    followingId
    copyWorkId
    fixedTimeTolerance
    systolicPressure
    diastolicPressure
    pulse
    breath
    glycemia
    spo2
    pain
    weight
    pulseByBeats
    pulseByTouch
    woundSize
    usedGloves
    temperature
    urineVolume
    userId
    datas
    personId
    person {
        ${personAppointmentFrag}
    }
    medications {
        id
        code
        dose
        folderMedicationId
        serviceId
        customMedicationName
        medication {
            name
            code
            strength
        }
    }
    procedures {
        id
        code
        applications
        frequency
        usualNumberOfApplications
        serviceId
        serviceMedicalProcedureId
        serviceMedicalProcedure {
            ${serviceMedicalProcedureGridItemFrag}
        }
        voucherPrescribedMedicalProcedureId
        voucherPrescribedMedicalProcedure {
            ${schedulerVoucherPrescribedMedicalProceduresFrag}
        }
    }
    services {
        id
        date
        workId
        serviceId
        folder {
            ${folderGridItemFrag}
            workplaces {
                ${folderWorkplaceFrag}
            }
            workgroup {
                ${folderWorkgroupGridItemFrag}
            }
        }
    }
`;
